import { CommentEntity } from 'mk2/apps/blogs/schemas';
import { memoizeOne } from 'mk2/helpers/cache';
import { AppState } from 'mk2/reducers';
import { CommentsState, initialCommentsState, PostsState } from './Comments.reducers';

export const getCommentsState = (state: AppState, postKey: string): CommentsState =>
    state.containers.blogs.shared.comments[postKey] || initialCommentsState;

export const getCommentsNonDeleted = memoizeOne(
    (comments: CommentEntity[]): CommentEntity[] => comments.filter((comment) => !comment.deletedAt),
);

export const getPostsState = (state: AppState): PostsState =>
    state.containers.blogs.shared.comments;

export const getCommentIdsOrNull = (state: PostsState, key: string) =>
    state[key] ? state[key].ids : null;
